import { configureStore } from '@reduxjs/toolkit';
import user from './user';
import banner from './banner';
export default configureStore({
    reducer: {
        user,
        banner,
    },
});
